import React from 'react';
import { Box, Typography } from '@mui/material';
import { ReactComponent as FableButterflyOutline } from '../images/fable-butterfly-outline.svg';
import { APP_TEXT_SECONDARY } from '../createShared';

/** The same welcome composition in Go, Gambit and the loading shell. */
export default function StoryWelcome({ accent = '#626672', className }: {
  accent?: string;
  className?: string;
}) {
  return <Box className={className} sx={{ width: '100%', py: { xs: '16px', sm: '32px' }, flex: 1,
    display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center' }}>
    <Box component={FableButterflyOutline} aria-hidden="true" focusable="false"
      sx={{ width: 'clamp(64px, 6vw, 88px)', height: 'auto', alignSelf: 'center', mb: 3, color: accent, flexShrink: 0 }} />
    <Typography component="h1" sx={{ color: '#fff', fontWeight: 900,
      fontSize: { xs: 23, sm: 27, md: 31, lg: 36 }, lineHeight: 1.05,
      letterSpacing: 0, textWrap: 'balance', mb: 1.1 }}>
      Watch the magic unfold...
    </Typography>
    <Typography sx={{ color: APP_TEXT_SECONDARY, fontSize: { xs: 14, sm: 15, md: 18 }, fontWeight: 650 }}>
      What story do you want to create?
    </Typography>
  </Box>;
}
